/*eslint-disable*/
export const businessData = [
  {
    slug: 'bus-ride-service',
    title: 'Bus Ride Service',
    desc: 'Purchase a ticket and book trips in advance at your convenience with just a click of a button...',
    icon: 'ride.png'
  },
  {
    slug: 'parcel',
    title: 'Parcel Service',
    desc: 'Receive and deliver your consignment safely to its destination with just a click of a button... ',
    icon: 'parcel.png'
  },
  {
    slug: 'hiring',
    title: 'Hiring Service',
    desc: 'Easily hire a bus for your business retreat, family vacation and road trips with Oya...',
    icon: 'hiring.png'
  },
  {
    slug: 'cargo-truck-service',
    title: 'Cargo-Truck Service',
    desc: 'We  provide heavy haulage transport,  and freight forwarding in Ghana ...',
    icon: 'cargo.png'
  }
]
